import { ViewportType } from '../../../enums/index.js';
import { getWSIProjectionPresentation, withWSIProjectionPresentation, } from './wsiProjectionPresentation.js';
import { getWSIProjectionSnapshot } from './wsiProjectionSnapshot.js';
import { WSI_PROJECTION_ID, } from './WSIProjectionTypes.js';
export { getWSIProjectionSnapshot };
export const wsiProjectionAdapter = {
    id: WSI_PROJECTION_ID,
    viewportTypes: [ViewportType.WHOLE_SLIDE_NEXT],
    getSnapshot: (request) => getWSIProjectionSnapshot(request),
    getPresentation: (snapshot, selector) => getWSIProjectionPresentation(snapshot, selector),
    withPresentation: (snapshot, presentation, options) => withWSIProjectionPresentation(snapshot, presentation, options),
};
